import Input from './input.vue';
export default Input;


// WEBPACK FOOTER //
// ./src/components/common/input/index.js